import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'Components';
import './ModalCenter.css';

const ModalCenter = ({ children }) => (
  <Modal show className="modal-center">
    <div className="modal-center__content">
      {children}
    </div>
  </Modal>
);

ModalCenter.propTypes = {
  children: PropTypes.node,
};

export default ModalCenter;



// WEBPACK FOOTER //
// ./src/components/ModalCenter/ModalCenter.jsx